import { useStatsigClient } from '@statsig/react-bindings'

export type StatsigGateName =
  | 'subscriptions_enabled'
  | 'subscription_otp_enabled'
  | 'subscription_address_update_message'
  | 'disable_edd_homepage_recommendations'
  | 'migrate_white_glove_delivery_tag'

/**
 * Hook to check Statsig gate status
 * @param gateName - The name of the gate to check
 * @returns boolean - true if gate is enabled, false otherwise
 */
export const useStatsigGate = (gateName: StatsigGateName): boolean => {
  const { checkGate } = useStatsigClient()
  try {
    return checkGate(gateName)
  } catch (error) {
    // Log the error but don't throw to prevent breaking non-critical features
    console.error('Failed while checking statsig gate', error)
    return false
  }
}
